// extracted by mini-css-extract-plugin
module.exports = {"enter":"box-accordion_animations_enter__3VqWC","enterActive":"box-accordion_animations_enterActive__13Qru","exitActive":"box-accordion_animations_exitActive__1nYJ3"};